var map = {
	"./clear1.png": 9972,
	"./clear2.png": 8783,
	"./clear3.png": 3686,
	"./clear3noHp.png": 4559,
	"./iconATK.png": 2145,
	"./iconDEF.png": 7690,
	"./iconEXPMULTI.png": 5687,
	"./iconHP.png": 2199,
	"./iconHPMULTI.png": 9016,
	"./iconLVL.png": 7029,
	"./iconMaxHP.png": 5053,
	"./lastInflator.png": 8043,
	"./legacy/auroraBadge.png": 6929,
	"./legacy/banishment.png": 475,
	"./legacy/bell.png": 9785,
	"./legacy/blazingSpirit.png": 4442,
	"./legacy/blessingDrum.png": 1285,
	"./legacy/blessingFlute.png": 547,
	"./legacy/blueMedicine.png": 8754,
	"./legacy/contBadge.png": 2125,
	"./legacy/deja.png": 8648,
	"./legacy/dotPendant.png": 9759,
	"./legacy/eternalBottle.png": 7899,
	"./legacy/fulfilled.png": 9777,
	"./legacy/greenMedicine.png": 809,
	"./legacy/guardian.png": 175,
	"./legacy/heavenBlessing.png": 2696,
	"./legacy/heroEmblem.png": 9804,
	"./legacy/knightEmblem.png": 3855,
	"./legacy/lastBless.png": 3005,
	"./legacy/lostPrayer.png": 2773,
	"./legacy/lunarIce.png": 3291,
	"./legacy/medicine.png": 7670,
	"./legacy/metalWorld.png": 7873,
	"./legacy/modestBless.png": 6245,
	"./legacy/moonBadge.png": 3452,
	"./legacy/moonFolklore.png": 7999,
	"./legacy/moonGate.png": 6528,
	"./legacy/nexusPendant.png": 4859,
	"./legacy/omegaMattock.png": 1954,
	"./legacy/rainbowBadge.png": 4461,
	"./legacy/realDrop.png": 3373,
	"./legacy/shiningKey.png": 2807,
	"./legacy/solarBlizzard.png": 9181,
	"./legacy/solarElixir.png": 7122,
	"./legacy/solarGate.png": 1934,
	"./legacy/solarGlory.png": 3328,
	"./legacy/solarMattock.png": 916,
	"./legacy/solarMirror.png": 4898,
	"./legacy/solarPave.png": 8465,
	"./legacy/solarSwap.png": 26,
	"./legacy/solarTele.png": 6123,
	"./legacy/solarWinner.png": 1286,
	"./legacy/summerDrop.png": 2418,
	"./legacy/summerMemories.png": 5604,
	"./legacy/sunsetIce.png": 2699,
	"./legacy/sunstoneCross.png": 2071,
	"./legacy/tempMiracle.png": 9763,
	"./legacy/ultraMattock.png": 2919,
	"./medalBronze.png": 8555,
	"./medalDiamond.png": 231,
	"./medalGold.png": 1945,
	"./medalMoon.png": 2056,
	"./medalPlatinum.png": 7755,
	"./medalSilver.png": 3696,
	"./medalSun.png": 4521,
	"./mysticgate.png": 4358,
	"./sunstone.png": 2181,
	"./sunwisher.png": 8600,
	"./wildcard/armsOfRealize.png": 647,
	"./wildcard/faithfulWill.png": 6494,
	"./wildcard/legsOfFreedom.png": 9310,
	"./wildcard/lightPerception.png": 4522,
	"./wildcard/magicTail.png": 132,
	"./wildcard/mysticEyes.png": 9830,
	"./wildcard/twistOfFate.png": 5235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;